import React from "react";
import { observer } from "mobx-react";
import { PermissionUpdateStore } from "../../store";
import { PermissionUpdateForm } from "./PermissionUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type PermissionUpdateProps = {
  permissionUpdateStore: PermissionUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const PermissionUpdate: React.FC<PermissionUpdateProps> = observer(
  ({ permissionUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={permissionUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={permissionUpdateStore.savedButOutdated}
          onReload={() => permissionUpdateStore.reloadPermission()}
          reloadDisabled={permissionUpdateStore.isProcessing}
        />
        <PermissionUpdateForm
          permissionUpdateStore={permissionUpdateStore}
          name_esError={permissionUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            permissionUpdateStore.setName_esValue(value);
          }}
          name_es={permissionUpdateStore.entityValues.name_es}
          name_enError={permissionUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            permissionUpdateStore.setName_enValue(value);
          }}
          name_en={permissionUpdateStore.entityValues.name_en}
          name_ptError={permissionUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            permissionUpdateStore.setName_ptValue(value);
          }}
          name_pt={permissionUpdateStore.entityValues.name_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={permissionUpdateStore.saveDisabled}
          onSave={() => permissionUpdateStore.savePermission()}
          onCancel={() => permissionUpdateStore.cancelPermission()}
        />
        <ErrorDialog
          open={permissionUpdateStore.errorDialogOpened}
          title={permissionUpdateStore.errorTitle}
          description={permissionUpdateStore.errorDescription}
          onClose={() => permissionUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={permissionUpdateStore.confirmDialogOpened}
          title={permissionUpdateStore.confirmDialogTitle}
          description={permissionUpdateStore.confirmDialogDescription}
          onConfirm={() => permissionUpdateStore.executeConfirmedAction()}
          onCancel={() => permissionUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
